import { appstr } from "../utils/appstr";
import { StringToBool } from "../utils/StringToBool";
import { QAccessRecord } from "./QAccessRecord";
import { QXMLObject } from "./QXMLObject";

export class QAccessMgr extends QXMLObject {
  constructor() {
    super();
    this.fRestricted = false;
    this.fCurUser = null;
    this.fCurAccessRecord = null;
    this.fAdmin = false;

    this.fDeptFieldName = null;
    this.fAccessRecordList = null;
    this.fTempAccessRecList = null;
    this.fTempDeptFieldName = null;
  }

  InitAccessMgr() {
    // curUser, isAdmin)
    this.SetXMLElementName("accessmgr");
    this.fAccessRecordList = [];
  }

  SetupAccessMgr(
    curUser,
    isAdmin // curUser, isAdmin)
  ) {
    this.fAdmin = isAdmin;
    this.fCurUser = curUser;

    this.LoadPrivs();
  }

  CopyPrior(priorAM) {
    this.fRestricted = priorAM.fRestricted;
    if (this.fRestricted == false) return;

    this.fDeptFieldName = priorAM.fDeptFieldName;

    this.fAccessRecordList = [];
    var n = priorAM.GetNumAccessRecords();
    for (var i = 0; i < n; i++) {
      var ar = priorAM.GetIndexAccessRecord(i);
      var nR = ar.Clone();
      this.fAccessRecordList.push(nR);
    }
  }

  LoadPrivs() {
    var curUser = this.fCurUser;
    curUser = curUser.toLowerCase();
    var starRecord = null;

    var n = this.GetNumAccessRecords();
    for (var i = 0; i < n; i++) {
      var ar = this.GetIndexAccessRecord(i);
      var arUser = ar.GetUserID();
      if (arUser.toLowerCase() == curUser) {
        this.fCurAccessRecord = ar;
        return;
      }
    }

    this.fCurAccessRecord = null;
  }

  GetDeptFieldName() {
    return this.fDeptFieldName;
  }

  GetNumAccessRecords() {
    return this.fAccessRecordList.length;
  }

  GetIndexAccessRecord(index) {
    return this.fAccessRecordList[index];
  }

  AccessMgrEnabled() {
    if (!this.IsAdmin()) return this.GetRestrictAccess();

    return false;
  }

  IsAdmin() {
    return this.fAdmin;
  }

  GetRestrictAccess() {
    return this.fRestricted;
  }

  SetRestrictAccess(restrictAccess) {
    this.fRestricted = restrictAccess;
  }

  GetAccessRecord() {
    return this.fCurAccessRecord;
  }

  ClearPrivs() {
    this.fAccessRecordList = new Array();
  }

  CanAccessCurrentDoc() {
    var aR = this.GetAccessRecord();
    if (aR == null) return false;
    return aR.GetAllowAccess();
  }

  IncludeDivision(divName) {
    // if (divName == null)
    //     return false;

    var ar = this.GetAccessRecord();
    if (ar == null) return false;

    var divList = ar.GetDivFilterList();
    return ar.IncludeElement(divList, divName);
  }

  IncludeDept(deptName) {
    //  if (deptName == null)
    //      return false;

    var ar = this.GetAccessRecord();
    if (ar == null) return false;

    var deptList = ar.GetDeptFilterList();
    return ar.IncludeElement(deptList, deptName);
  }

  OutputSubElements(stream) {
    this.OutputSimpleElement("accesson", this.fRestricted, stream);
    this.OutputSimpleElement("deptfield", this.fDeptFieldName, stream);
  }

  LoadSubElements(objTree) {
    var isRestricted = objTree.GetValueForChild("accesson", false);
    if (isRestricted) {
      this.SetRestrictAccess(StringToBool(isRestricted));
      this.fDeptFieldName = objTree.GetValueForChild("deptfield", false);
    }
  }

  LoadChildElements(objTree) {
    if (this.fRestricted == false) return;

    var childList = objTree.GetChildOfTypeList("accessrec");
    var n = childList.length;
    for (var i = 0; i < n; i++) {
      var recInfo = childList[i];
      var accessRec = new QAccessRecord();
      accessRec.InitAccessRecord();
      accessRec.LoadFromXML(recInfo);
      this.fAccessRecordList.push(accessRec);
    }
  }

  OutputChildElements(stream) {
    var n = this.GetNumAccessRecords();
    for (var i = 0; i < n; i++) {
      var aRec = this.GetIndexAccessRecord(i);
      aRec.OutputToXML(stream);
    }
  }

  TempLoadPrivs(objTree) {
    var childList = objTree.GetChildOfTypeList("r");
    var n2 = childList.length;
    if (n2 < 1) return appstr("invalidaccesspriv1");

    var deptFieldName = null;
    var header = objTree.GetChildByName("header");
    if (header) {
      var fields = header.GetChildOfTypeList("field");
      if (fields && fields.length >= 4) {
        var deptField = fields[3];
        var deptFieldName = deptField.GetValue().toString().trim();
        if (deptFieldName.length == 0) deptFieldName = null;
      }
    }

    this.fTempDeptFieldName = deptFieldName;
    if (deptFieldName == null) return appstr("invalidaccesspriv3");

    this.fTempAccessRecList = new Array();
    for (var i = 0; i < n2; i++) {
      var r = childList[i];
      var childList2 = r.GetChildOfTypeList("d");
      var dl = childList2.length;
      if (dl >= 2) {
        var ar = new QAccessRecord();
        ar.InitAccessRecord();
        for (var k = 0; k < 4; k++) {
          var key1 = childList2[k];
          var keyVal = key1.GetValue();
          keyVal = keyVal.trim();
          var dataErr = false;
          switch (k) {
            case 0:
              dataErr = keyVal.length == 0;
              ar.SetUserID(keyVal);
              break;
            case 1:
              dataErr = keyVal.length == 0;
              var allowAccess = false;
              if (keyVal.toLowerCase() == "yes") allowAccess = true;
              ar.SetAllowAccess(allowAccess);
              break;
            case 2:
              var divList = keyVal.split("|");
              ar.SetDivFilterList(divList);
              break;
            case 3:
              var deptList = keyVal.split("|");
              ar.SetDeptFilterList(deptList);
              break;
          }

          if (dataErr) {
            var k2 = i + 2;
            return appstr("invalidaccesspriv2") + k2.toString();
          }
        }

        this.fTempAccessRecList.push(ar);
      }
      //  else {
      //      this.fTempAccessRecList = null;
      //      return appstr("invalidaccesspriv3");
      //  }
    }

    return appstr("validaccesspriv");
  }

  CommitPrivs(objTree) {
    if (this.fTempAccessRecList == null) return false;

    this.fAccessRecordList = this.fTempAccessRecList;
    this.fDeptFieldName = this.fTempDeptFieldName;
    return true;
  }
}
